import { graphql } from "react-relay";

export const ssoAdminPortalButtonFragments = {
  org: graphql`
    fragment SsoAdminPortalButton_org on Org {
      id
    }
  `,
  billingGroup: graphql`
    fragment SsoAdminPortalButton_billingGroup on BillingGroupErrorable {
      ... on BillingGroup {
        id
        type
        ssoAdminPortalLink {
          __typename
          ... on SsoAdminPortalLink {
            link
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
      ... on GraphEntityError {
        message
        statusCode
      }
    }
  `,
};

export const ssoAdminPortalButtonQuery = graphql`
  query SsoAdminPortalButtonQuery($orgRelayId: ID!, $billingGroupId: String!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        id
        ...SsoAdminPortalButton_org
        billingGroupForId(billingGroupId: $billingGroupId) {
          ...SsoAdminPortalButton_billingGroup
        }
      }
    }
  }
`;
